// removed by extract-text-webpack-plugin
module.exports = {"sm":"only screen and (min-width: 48em)","placeholderGray":"#9297A3","container":"container-3-8B-","calculateButton":"calculateButton-2w7CK","calorieLabel":"calorieLabel-1lKwd","autoCalculate":"autoCalculate-2CWe5","calculateButtonText":"calculateButtonText-3g3y6","calcCaloriesError":"calcCaloriesError-SJo1E","afterCalories":"afterCalories-2PbVD","fieldUnit":"fieldUnit-HEsM2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/workouts/WorkoutForm/_calorieCalculator.css
// module id = 1284
// module chunks = 1